export const DEFAULT_INFO_MARKDOWN = `## ¿Qué es CROWDS?

CROWDS te permite ser parte del contenido del evento.

Cómo funciona:

1. Graba clips cortos desde tu celular
2. Completa desafíos creativos y participa por recompensas.
3. Sube tu contenido a la plataforma

Tu contenido contribuye a documentar la experiencia colectiva del evento.

## Términos y Condiciones — CROWDS

### 1. Aceptación de los términos

Al acceder y utilizar la plataforma CROWDS, el usuario acepta estos Términos y Condiciones. CROWDS se reserva el derecho de actualizar estos términos cuando sea necesario.

### 2. Descripción del servicio

CROWDS es una plataforma digital que permite a los asistentes de un evento:

- grabar clips de video
- participar en challenges o dinámicas creativas
- subir contenido al sistema
- contribuir a la creación de contenido colectivo del evento.

El contenido generado puede ser utilizado para crear compilaciones, reels u otros formatos audiovisuales relacionados con el evento.

### 3. Uso responsable

No está permitido subir contenido que:

- infrinja derechos de terceros
- contenga violencia, acoso o discriminación
- incluya material ilegal o explícito
- viole normas del evento o de la plataforma.

CROWDS se reserva el derecho de eliminar contenido que incumpla estas reglas.

### 4. Derechos sobre el contenido

El usuario conserva la propiedad del contenido que genera.

Al subir contenido a CROWDS, el usuario concede a CROWDS, al organizador del evento y a sponsors del evento una licencia no exclusiva para:

- almacenar el contenido
- editarlo
- integrarlo en compilaciones o reels
- utilizarlo en comunicaciones relacionadas con el evento o con la plataforma.

Este uso puede incluir:

- redes sociales
- resúmenes del evento
- materiales promocionales del evento o de CROWDS.

### 5. Uso del contenido por parte del evento y sponsors

El contenido generado podrá ser utilizado por:

- CROWDS
- el organizador del evento
- sponsors o partners del evento

exclusivamente en el contexto de comunicación, promoción o documentación del evento.

Esto puede incluir:

- publicaciones en redes sociales
- recap videos
- contenido relacionado con la activación o experiencia del evento.

El contenido no será utilizado para campañas publicitarias independientes fuera del contexto del evento sin consentimiento adicional.

### 6. Grabación de otras personas

El usuario entiende que el contenido puede incluir imágenes de otras personas presentes en el evento.

El usuario se compromete a:

- respetar la privacidad de los demás asistentes
- evitar grabar contenido que pueda resultar ofensivo o invasivo.

### 7. Eliminación de contenido

CROWDS puede revisar, moderar o eliminar contenido que viole estos términos, y restringir el acceso a usuarios que hagan uso indebido de la plataforma.

### 8. Limitación de responsabilidad

CROWDS actúa como una plataforma que facilita la creación y recopilación de contenido generado por usuarios.

CROWDS no es responsable por el contenido publicado por los usuarios.

### 9. Privacidad y datos

CROWDS puede recopilar datos técnicos necesarios para el funcionamiento de la plataforma, tales como:

- métricas de uso
- interacción con la plataforma
- estadísticas agregadas del evento.

Estos datos se utilizan únicamente para mejorar el servicio y analizar el funcionamiento del producto.

CROWDS no vende ni comparte información personal de los usuarios para fines de marketing dirigido.

### 10. Contacto

Para consultas relacionadas con estos términos o solicitudes relacionadas con contenido, contactar a: [hola@crowds.cl](mailto:hola@crowds.cl)
`;
